import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PeiState {
  id: string | null;
}

const initialState: PeiState = {
  id: null,
};

const peiSlice = createSlice({
  name: 'peiId',
  initialState,
  reducers: {
    setPeiId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    clearPeiId: state => {
      state.id = null;
    },
  },
});

export const { setPeiId, clearPeiId } = peiSlice.actions;
export default peiSlice.reducer;
